var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('orderController', ['$scope', '$window', 'orderService', function ($scope, $window, orderService) {
    getOrder($window.orderNumber);

    function getOrder(orderNumber) {
        orderService.getOrder(orderNumber).then(function (response) {
            if (response && response.data) {
                $scope.order = response.data;
            }
        });
    }
}]);

storefrontApp.controller('orderConfirmationController', ['$scope', '$window', 'orderService', 'securityService', '$q', function ($scope, $window, orderService, securityService, $q) {
    $ctrl = this;
    $ctrl.sendingInvite = false;
    $ctrl.inviteSent = false;
    $ctrl.inviteError = false;

    getOrder($window.orderNumber);

    function getOrder(orderNumber) {
        var orderPromise = orderService.getOrder(orderNumber).then(function (response) {
            if (response && response.data) {
                $ctrl.order = response.data;
            }

            securityService.createGuestInvite().then(function (response) {
                if (response && response.data) {
                    $ctrl.tokenInfo = response.data;
                    securityService.logout();
                }
            });
        });
    }

    $ctrl.sendGuestInvite = function () {

        $ctrl.inviteError = false;
        $ctrl.sendingInvite = true;

        securityService.submitGuestInvite($ctrl.tokenInfo.userId, $ctrl.tokenInfo.token).then(function (response) {
            $ctrl.sendingInvite = false;
            $ctrl.inviteSent = true;
        },
        function (response) {
            $ctrl.sendingInvite = false;
            $ctrl.inviteError = true;
        });
    };

}]);
